import { IconsEnum } from '@enums/icons.enum';

import { DS_REGISTERED_ICON_NAMES } from '@design-system/ds-icon/properties/ds-icon.properties';

/**
 * Returns whether the name maps to a registered SVG icon in `IconsEnum`.
 *
 * @param name - Material ligature name or `IconsEnum` value
 * @returns true when the name should render as an SVG icon
 */
export function isRegisteredDsIcon(name: string | IconsEnum | null | undefined): boolean {
  if (!name) {
    return false;
  }

  return DS_REGISTERED_ICON_NAMES.has(name);
}
